module.exports = "/images/c2332e25935f6623d323f9eab4cd7d7d.png";